import PropTypes from 'prop-types';
import Option from './Option';
import { classes } from '@/helpers/styling';

const DropDownSelectOptions = ({
  open,
  onClose,
  onClickOption,
  options,
  selectedId,
  isSelectable,
  OptionComponent,
  className,
  optionClassName
}) => {
  const handleClickOption = (...args) => {
    if (onClickOption) {
      onClickOption(...args);
    }
    onClose();
  };
  
  return (
    <div
      className={ classes(
        className,
        'drop-down__options',
        { '--is-open': open }
      ) }
    >
      { options.map((o) => (
        <Option
          className={ optionClassName }
          href={ o.href }
          id={ o.id }
          isExternalHref={ o.isExternalHref }
          isSelectable={ isSelectable }
          key={ o.id }
          onClick={ handleClickOption }
          OptionComponent={ OptionComponent }
          selected={ o.id === selectedId }
          value={ o.value }
        />
      )) }
    </div>
  );
};

DropDownSelectOptions.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  onClickOption: PropTypes.func,
  options: PropTypes.array,
  selectedId: PropTypes.string,
  isSelectable: PropTypes.bool,
  OptionComponent: PropTypes.element,
  className: PropTypes.string,
  optionClassName: PropTypes.string
};

DropDownSelectOptions.defaultProps = {
  onClickOption: undefined,
  open: false,
  options: [],
  selectedId: undefined,
  isSelectable: false,
  OptionComponent: undefined,
  className: '',
  optionClassName: ''
};

export default DropDownSelectOptions;